import { Injectable, inject } from '@angular/core';
import { HttpClientService } from '../../../auxiliares/servicios/http.service';

export interface IndiceAyuda {
  version: string;
  generadoEn: string;
  grupos?: GrupoAyuda[];
  categorias: CategoriaAyuda[];
}

/**
 * Familia de categorías: separa la ayuda de operación del sistema de la de
 * configuración de los equipos de campo. El front las muestra como pestañas.
 * Es opcional porque un bundle viejo no la trae.
 */
export interface GrupoAyuda {
  id: string;
  titulo: string;
  subtitulo?: string;
  icono?: string;
  orden?: number;
}

export interface CategoriaAyuda {
  id: string;
  titulo: string;
  icono: string;
  grupo?: string;
  /** Ver {@link SubcategoriaAyuda.tiposCliente}. */
  tiposCliente?: string[];
  subcategorias: SubcategoriaAyuda[];
}

export interface SubcategoriaAyuda {
  id: string;
  titulo: string;
  /** Tipos de cliente que la ven, declarado en el bundle. La API ya la filtra,
   *  así que si llega es porque corresponde; está en el tipo para no perder el
   *  dato y para poder gatear en el front sin otra fuente. */
  tiposCliente?: string[];
  articulos: ArticuloRef[];
}

export interface ArticuloRef {
  id: string;
  titulo: string;
  slug: string;
  resumen: string;
  tags: string[];
  archivo: string;
}

export interface Articulo {
  id: string;
  titulo: string;
  slug: string;
  categoria: string;
  subcategoria: string;
  contenido: string;
  formato: string;
  tags: string[];
}

export interface BundleAyuda {
  version: string;
  generadoEn: string;
  grupos?: GrupoAyuda[];
  categorias: CategoriaAyuda[];
  articulos: Record<string, { titulo: string; contenido: string }>;
}

export interface ResultadoBusqueda {
  id: string;
  titulo: string;
  slug: string;
  resumen: string;
  relevancia: number;
  fragmento: string;
}

@Injectable({ providedIn: 'root' })
export class AyudaService {
  private http = inject(HttpClientService);

  public getBundle(): Promise<BundleAyuda> {
    return this.http.get(`/ayuda/bundle`);
  }

  public getIndice(): Promise<IndiceAyuda> {
    return this.http.get(`/ayuda/indice`);
  }

  public getArticulo(slug: string): Promise<Articulo> {
    return this.http.get(`/ayuda/articulos/${slug}`);
  }

  public buscar(
    query: string,
  ): Promise<{ resultados: ResultadoBusqueda[]; total: number }> {
    return this.http.get(`/ayuda/buscar`, { params: { q: query } as any });
  }
}
